import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SearchService {
  url = "/api/search";

  constructor(private http: HttpClient) { }

  all(params): Observable<any> {
    return this.http.get<any>(this.url + "/topbar", { params: params });
  }
  onlyPeople(params): Observable<any> {
    return this.http.get<any>(this.url + "/people", { params: params });
  }
}
